/* eslint no-underscore-dangle: 0 */
import React from 'react';
import { connect } from 'react-redux';
import Table from 'react-toolbox/lib/table';
import * as recipe from '~/actions/recipe';
import { Button } from 'react-toolbox/lib/button';
import Tag from '~/components/Tag';
import ArticlePicker from '~/components/ArticlePicker';
import RawMaterialPicker from '~/components/RawMaterialPicker';
import style from './style.scss';

const tableHeadersRecipes = {
  name: { type: String },
  components: { type: String },
  action: { type: String, title: ' ' },
};

class Production extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired,
    router: React.PropTypes.object.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    recipe.list(this.props.dispatch, this.context.apiClient);
  }

  render() {
    return (
      <div style={{ padding: '10px' }}>
        <Button
          label="BOL"
          onClick={() => this.context.dialogPush('recipe')}
          primary
          raised
          className={style.buttonNew}
          icon="add"
        />
        <div className={style.title}>Production</div>
        <div className={style.filters}>
          <b>Filters</b>
          <div className={style.filter}>
            <div className={style.label}>Name</div>
            <div className={style.item}>
              <input placeholder="Recipe name" value={this.state.filterName} onChange={e => this.setState({ filterName: e.target.value })} />
            </div>
          </div>
          <div className={style.filter}>
            <div className={style.label}>Consumes</div>
            <div className={style.item}>
              <RawMaterialPicker
                value={this.state.filterRawMaterial}
                onChange={v => this.setState({ filterRawMaterial: v })}
              />
            </div>
          </div>
          <div className={style.filter}>
            <div className={style.label}>Produces</div>
            <div className={style.item}>
              <ArticlePicker
                value={this.state.filterArticle}
                onChange={v => this.setState({ filterArticle: v })}
              />
            </div>
          </div>
        </div>
        <Table
          model={tableHeadersRecipes}
          selectable={false}
          source={Object.values(this.props.recipes)
            .filter(i => {
              if (i.removed) { return false; }
              if (this.state.filterName) {
                if (i.name.substr(0, this.state.filterName.length).toUpperCase()
                  !== this.state.filterName.toUpperCase()) { return false; }
              }
              if (this.state.filterArticle) {
                if (!i.articles.find(a => a.id === this.state.filterArticle)) { return false; }
              }
              if (this.state.filterRawMaterial) {
                if (!i.materials.find(m => m.id === this.state.filterRawMaterial)) { return false; }
              }
              return true;
            })
            .map(i => ({
              ...i,
              components: <div className={style.tags}>
                {i.materials.map(m => <Tag key={m.id} type="rawMaterial" id={m.id} />)}
                <br />
                {i.articles.map(a => <Tag key={a.id} type="article" id={a.id} />)}
              </div>,
              action: <Button
                primary
                raised
                label="Make products"
                onClick={e => { e.stopPropagation(); this.context.dialogPush('produce', { recipe: i }); }}
                style={{
                  position: 'absolute',
                  right: 0,
                  top: '5px',
                }}
              />
            }))
          }
          onRowClick={i => this.context.dialogPush('recipe', { item: Object.values(this.props.recipes)[i] })}
          className={style.table}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  recipes: state.getIn(['recipe', 'items']).toJS(),
});

export default connect(mapStateToProps)(Production);



// WEBPACK FOOTER //
// ./app/pages/Production/index.js